import { FlexEntity } from "../models/generated/graphql";

export const deserializeFlexEntityData = <T>(value: T): T => {
	if (!value) {
		return value;
	}

	if (
		typeof value === "object" &&
		(value as unknown as FlexEntity).__typename === "FlexEntity" &&
		typeof (value as unknown as FlexEntity).data === "string"
	) {
		return deserializeFlexEntityData({
			...value,
			data: JSON.parse((value as unknown as FlexEntity).data),
		});
	}

	if (Array.isArray(value)) {
		let output: Array<unknown> | undefined = undefined;
		for (const [index, item] of value.entries()) {
			const deserializedItem = deserializeFlexEntityData(item);
			if (deserializedItem !== item) {
				output ??= value.slice(index);
			}

			output?.push(item);
		}

		return (output ?? value) as unknown as T;
	}

	if (typeof value !== "object") {
		return value;
	}

	let output: object | undefined = undefined;
	for (const key in value) {
		const deserializedItem = deserializeFlexEntityData(value[key]);
		if (deserializedItem !== value[key]) {
			output = { ...value } as object;
		}

		if (output) {
			(output as any)[key] = deserializedItem;
		}
	}

	return (output ?? value) as unknown as T;
};
